// extracted by mini-css-extract-plugin
export default {"item":"ColorfulList_item__CwYG1","itemSelected":"ColorfulList_itemSelected__XSenJ","content":"ColorfulList_content__+S738"};